import gql from 'graphql-tag';

const CLUB_TRANSFER_REQUEST_TABLE= gql`
query clubTransferRequestsTable($offset: Int, $limit: Int, $sort: [ClubTransferRequestsTableSortInput!], $filter: [ClubTransferRequestsTableFilterInput]) {
  clubTransferRequestsTable (offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
      totalCount,
      items {
        id
        bid
        status
        year
        member
        sourceClub
        targetClub
        memberId
        sourceClubId
        targetClubId
        memberResponse
        sourceClubResponse
        targetClubResponse
        expiresIn
      }
  }
}
`;

export default CLUB_TRANSFER_REQUEST_TABLE;